import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const PMSUserStore = GenericFieldFactory("PMS_USER");